import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import Characters from "@/pages/home/components/Characters";
import StoryArc from "@/pages/home/components/StoryArc";
import FanWorks from "@/pages/home/components/FanWorks";
import Doujin from "@/pages/home/components/Doujin";
import ResourceHub from "@/pages/home/components/ResourceHub";
import ReadingGuide from "@/pages/home/components/ReadingGuide";
import Updates from "@/pages/home/components/Updates";
import Faq from "@/pages/home/components/Faq";
import Discussion from "@/pages/home/components/Discussion";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Characters />
        <StoryArc />
        <FanWorks />
        <Doujin />
        <ResourceHub />
        <ReadingGuide />
        <Updates />
        <Faq />
        <Discussion />
      </main>
      <Footer />
    </div>
  );
}